import React, { Component } from 'react';
import { Text, View, Image, Platform, StyleSheet, Linking } from 'react-native';

import { Utils, OPComponent, IconButton, NavBar, I18n, Navigation, Alert } from './components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAssociatedEmployer } from '../selectors/employers';

import { COLOR, FONT, FONT_SIZE, THEME } from '../constants/styles';

class Help extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;
  static navigatorButtons = NavBar && {
    leftButtons: [NavBar.buttons.done],
  };

  constructor(props) {
    super(props);
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;
    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  goToPhone = () => {
    let phoneNumber = this.props.employer.opSupportPhone;
    Utils.openPhone(phoneNumber).catch((err) => {
      Alert.alert(
        I18n.t('help.phoneAppNotAvailable'),
        I18n.t('help.pleaseCall', { phone: phoneNumber })
      );
    });
  };

  goToEmail = () => {
    let employer = this.props.employer;
    let emailAddress = employer.opSupportEmail || 'support@outpatient.zendesk.com';

    Utils.goToEmail(emailAddress);
  };

  goToPrivacyEmail = () => {
    Utils.goToEmail('privacy@outpatient.ai');
  };

  render() {
    let { userProfile, employer } = this.props;
    let displayName = userProfile?.friendlyName || userProfile?.fullName;
    let employerImageUri = employer && Utils.employerImagePath(employer.employerId);

    // console.info('employerImageUri', employerImageUri);
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Image
            style={styles.employerImage}
            source={{ uri: employerImageUri }}
            resizeMode="contain"
          />
          <Text style={styles.helloText}>{I18n.t('help.helloName', { name: displayName })}</Text>
          <Text style={styles.helloSubText}>{I18n.t('help.tapAnOptionForHelp')}</Text>
        </View>

        <IconButton
          label={I18n.t('help.callSupportRep')}
          imageSource={require('../../resources/icon-support-rep.png')}
          onPress={this.goToPhone}
        />
        <IconButton
          label={I18n.t('help.emailQuestion')}
          imageSource={require('../../resources/icon-email-support-question.png')}
          onPress={this.goToEmail}
          noTopBorder={true}
        />
        <IconButton
          label={I18n.t('help.emailPrivacyQuestion')}
          imageSource={require('../../resources/icon-email-privacy-question.png')}
          onPress={this.goToPrivacyEmail}
          noTopBorder={true}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  header: {
    backgroundColor: COLOR.altContrast,
    height: 200,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  employerImage: {
    height: 80,
    width: 80,
    alignSelf: 'center',
    marginBottom: 10,
  },
  helloText: {
    ...FONT.bold,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
    textAlign: 'center',
    marginBottom: 5,
  },
  helloSubText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
    textAlign: 'center',
  },
});

function mapStateToProps(state, ownProps) {
  return {
    userProfile: state.entities.userProfile,
    employer: getAssociatedEmployer(state),
  };
}

export default connect(mapStateToProps)(Help);
